'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');let

TermsConfig=class TermsConfig{
static get $inject(){return['$stateProvider']}

constructor($stateProvider){
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('terms');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=TermsConfig;
//# sourceMappingURL=termsConfig.js.map
